import "../CSS/Vcdeviceregistation.css";
import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { FaEye } from "react-icons/fa";
import { getAPIHostURL } from "../../ClientConfig";
import { AppRelevantDataContext } from "../../AppContext";
import { FaQrcode, FaTimes } from "react-icons/fa";
import { PROD_DEVC_OWNER_USER_ID, SAU_ProductLine} from '../../VcConstants';
import { QrScanner } from "@yudiel/react-qr-scanner";
import { Divider} from "antd";
import { CheckCircleFilled, InfoCircleFilled } from "@ant-design/icons";

function VcCreateSauDevice(props) {
  const context = useContext(AppRelevantDataContext);

  const [state, setState] = useState({
    deviceID: "",
    arrDeviceList: [],
    HardwareModelArr: [],
    SoftwareNameArr: [],
    deviceBatchArr: [],
    devcIDQRCodeFlag: false,
    selectedHwModel: "",
    selectedSWName: "",
    selectedSwVersion: "",
    selectedBatchNo: "",
    HWandSWVersionInfoArr: [],

    errors: {
      errors:"",
      deviceExistenceErr: "",
      deviceID:"",
      arrDeviceList: "", 
      others: "",
      selectedHwModel: "",
      selectedSWName: "",
      selectedSwVersion: "",
      selectedBatchNo: "",
    },
  });

  // ===== Derived Dropdown Data =====
  // Contains all unique hardware models from the HWandSWVersionInfoArr API response
  const hardwareModels = [
    ...new Set(
      (state.HWandSWVersionInfoArr || []).map(x => x.ModelName)
    )
  ];

  // Contains all unique software names filtered by the selected hardware model from the HWandSWVersionInfoArr API response
  const softwareNames = [
    ...new Set(
      (state.HWandSWVersionInfoArr || [])
        .filter(x => x.ModelName === state.selectedHwModel)
        .map(x => x.SoftwareName)
    )
  ];

  // Contains all unique software versions filtered by the selected hardware model and software name from the HWandSWVersionInfoArr API response
  const versions = [
    ...new Set(
      (state.HWandSWVersionInfoArr || [])
        .filter(x =>
          x.ModelName === state.selectedHwModel &&
          x.SoftwareName === state.selectedSWName
        )
        .map(x => x.Version)
    )
  ];

  const { errors } = state;
  let appRelevantDataContextValue = context; 
  let t = appRelevantDataContextValue.t;

  // On component mount, fetch the hardware model and software version info to populate the dropdowns
  useEffect(() => {
    getHWModelandSWversionInfo();
  }, []);

  // Function Handler for when the device ID input changes. Converts input to uppercase and resets related errors and flags.
  const onChangedeviceID = (e) => {
    const value = e.target.value.toUpperCase(); // Convert to uppercase
    setState((prev) => ({
      ...prev,
      deviceID: value,
      devcIDQRCodeFlag: false,
      errors: {
        ...prev.errors,
        deviceID: "",
        deviceExistenceErr: "",
        arrDeviceList: "",
        others: ""
      },
    }));
  };

  // Function Handler to open the QR code scanner for device ID input. Checks for camera permissions before toggling the scanner visibility.
  const openQRCameraForPrdItmStateDevcID = async () => {
    console.log("Attempting to open QR scanner for Device ID input...");
    const result = await navigator.permissions.query({ name: "camera" });
    if (result.state === "denied") {
      return;
    }

    setState((prev) => {
      return {
      ...prev,
      devcIDQRCodeFlag: !prev.devcIDQRCodeFlag,
      deviceID: "",
      errors: {
        ...prev.errors,
        deviceExistenceErr: "",
      },
    }});
  };

    // UI Components for Notes and Instructions to the user
  const noteForUser = () => {
    return(
      <div style={{border: "1px solid #a8cca8", textAlign:"left", borderRadius:"0.5rem", marginBottom:"1rem", paddingTop:"0.5rem", paddingBottom:"0.5rem"}} >
          <div style={{fontSize:"0.8rem", fontWeight:"bold", marginLeft:"0.5rem"}}>Important Note:</div>
          <div style={{fontSize:"0.8rem", marginLeft:"0.5rem", marginRight:"0.5rem"}}>
              This feature is specifically designed and expected to use for <b>Smart Automation Unit (SAU)</b> devices.
              <br/>
          </div>
          <div style={{fontSize:"0.8rem", fontWeight:"bold", marginLeft:"0.5rem", marginTop:"0.2rem"}}>What Happens After Device Creation?</div>
          <div style={{fontSize:"0.8rem", marginLeft:"0.5rem", marginRight:"0.5rem"}}>
              Successfully created devices are automatically assigned the<b> "Ready for Shipment"</b> state.                 
          </div>
          <div style={{fontSize:"0.8rem", fontWeight:"bold", marginLeft:"0.5rem", marginTop:"0.2rem"}}>
              Who Can Perform This Action ?
          </div>
          <div style={{fontSize:"0.8rem", marginLeft:"0.5rem", marginRight:"0.5rem"}}>
              A CRM user having 'ProductionSupervisor' privilege.
              <br />
          </div>
      </div>
    )
  }

  // Note component to inform users about the irreversible nature of device creation and to double-check details before proceeding.
  const irreversibleActionNote = () => {
    return(
      <div style={{border: "1px solid #f48f67", textAlign:"left", borderRadius:"0.5rem", marginBottom:"0.5rem", paddingTop:"0.5rem", paddingBottom:"0.5rem"}} >
          <div style={{fontSize:"0.8rem", fontWeight:"bold", marginLeft:"0.5rem"}}>
            <b>Irreversible Action</b> — Once a device is created, its details cannot be changed. Double-check the Device ID, Hardware Model, Firmware Version, and Batch No. before clicking the button below.
          </div>
      </div>
    )
  }

  // Function Handler for when a QR code is successfully scanned. Sets the scanned value as the device ID and closes the scanner.
  const handleScanResultOfPrdItmStateDevcID = (data) => {
    console.log("QR scan result for Device ID:", data);
    if (!data) return;

    setState((prev) => ({
      ...prev,
      deviceID: data,
      devcIDQRCodeFlag: false,
    }));
  };

  // Function Handler for adding a device to the list. Validates the device ID format, checks for duplicates, and updates the state with the new device if valid.
  const addDevices = (e) => {
    e.preventDefault();
    let modifiedState = { ...state };
    modifiedState.errors = {
      ...modifiedState.errors,
      others: "",
      arrDeviceList: "",  
      deviceID: "",
    };

    let appRelevantDataContextValue = context;
    let t = appRelevantDataContextValue.t;

    modifiedState.errors.deviceID = (modifiedState.deviceID == null || modifiedState.deviceID.length <= 0) ? "Please enter Device ID" : "";

    // 2. Length must be exactly 12
    if (modifiedState.deviceID.length !== 12) {
      modifiedState.errors.deviceID = "Invalid Device ID";
      setState(modifiedState);
      return;
    }

    // 3. Must be valid hex (0–9 and A–F only)
    if (!/^[0-9A-F]{12}$/.test(modifiedState.deviceID)) {
      modifiedState.errors.deviceID = "Invalid Device ID";
      setState(modifiedState);
      return;
    }

    if( modifiedState.errors.deviceID) {
      setState(modifiedState);
      return;
    }

    //Prevent duplicate DeviceID BEFORE API call
    if (
      modifiedState.arrDeviceList.some(
        device => device.id === modifiedState.deviceID
      )
    ) {
      alert( `Device ID '${modifiedState.deviceID}' is already added.`);
      return; //stop API call
    }
    
    // Adding the devices to the list if all the conditions are satisfied.
    if (!modifiedState.arrDeviceList.some(
      device => device.id === modifiedState.deviceID

    )) 

    modifiedState.arrDeviceList = [
      {
        id: modifiedState.deviceID
      },
      ...modifiedState.arrDeviceList,
    ];

    modifiedState.errors.arrDeviceList = "";
    modifiedState.deviceID = "";
    modifiedState.errors.others = "";
    modifiedState.errors.deviceID = "";

    setState(modifiedState);  
  }

  // Function Handler for removing a device from the list. Filters out the device to be removed and updates the state. Also resets related fields if the removed device was the last one.
  const removeDevice = (deviceIDToRemove) => {
    setState((prev) => {
      const newArr = prev.arrDeviceList.filter(
        (device) => device.id !== deviceIDToRemove
      );
      // If you remove the last device or any device, reset related fields
        return {
          ...prev,
          arrDeviceList: newArr,
          // Only reset these if needed
          deviceID: "",
          errors: {
            ...prev.errors,
            deviceID: "",
            arrDeviceList: "",
            others: "",
          },
        };
    });
  };

  // Function to handle changes in the dropdowns for hardware model, software name, software version, and batch number. It updates the selected values in the state and resets related errors.
  const handleChange = (event) => {
    const { name, value } = event.target;
    let errors = { ...state.errors };
    switch (name) {

      case "selectedHwModel":
        errors.selectedHwModel = "";
        setState({
          ...state,
          selectedHwModel: value,
        });
      break;

      case "selectedBatchNo":
        errors.selectedBatchNo = "";
        setState({
          ...state,
          selectedBatchNo: value,
        });
      break;

      case "selectedSwVersion":
        errors.selectedSwVersion = "";
        setState({
            ...state,
            selectedSwVersion: value,
          });
      break;

      case "selectedSWName":
        errors.selectedSWName = "";
        setState({
            ...state,
            selectedSWName: value,
          });
      break;
    }
    setState((prev) => ({
      ...prev,
      [name]: value,
      errors: {
        ...prev.errors,
        ...errors,
        others: "", // clear generic errors too
      },
    }));
  };

  // Function to render the creation summary note after attempting to create devices. It displays the success/failure status, counts, and groups failed devices by error reason.
  const creationSummaryNote = () => {
    const summary = state.creationSummary;
    if (!summary) return null;

    const allSuccess = summary.failedCount === 0;
    const allFailed  = summary.successCount === 0;

    const cardStyle = {
      marginBottom: "1rem",
      borderRadius: "10px",
      border: `0.5px solid ${allSuccess ? "#1D9E75" : allFailed ? "#A32D2D" : "#185FA5"}`,
      background: allSuccess ? "#E1F5EE" : allFailed ? "#fcf4f4" : "#E6F1FB",
      padding: "0.9rem 1.1rem",
      fontFamily: "inherit",
    };

    const statusColor = allSuccess ? "#085041" : allFailed ? "#791F1F" : "#0C447C";
    const dividerColor = allSuccess ? "#9FE1CB" : allFailed ? "#F7C1C1" : "#B5D4F4";

    const badgeBase = {
      fontSize: "12px",
      fontWeight: 500,
      padding: "3px 10px",
      borderRadius: "6px",
      marginLeft: "5px",
    };

    const groupHeaderBase = {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      padding: "7px 11px",
      fontSize: "12px",
      fontWeight: 500,
      cursor: "pointer",
      userSelect: "none",
      borderRadius: "7px 7px 0 0",
    };

    const tagBase = {
      fontSize: "11px",
      fontFamily: "monospace",
      padding: "2px 8px",
      borderRadius: "4px",
      display: "inline-block",
    };

    return (
      <div style={cardStyle}>

        {/* ── Header row: status + badges ── */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "8px" }}>

          <div style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "14px", fontWeight: 500, color: statusColor }}>
            <span style={{
              width: "8px", height: "8px", borderRadius: "50", flexShrink: 0, display: "inline-block",
              background: allSuccess ? "#cdf6e9" : allFailed ? "#A32D2D" : "#185FA5",
              borderRadius: "50%",
            }} />
            {allSuccess ? "All devices created successfully" : allFailed ? "Device creation failed" : "Completed with some issues"}
          </div>

          <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
            <span style={{ ...badgeBase, background: "#5DCAA5", color: "#04342C" }}>
              {summary.successCount} created
            </span>
            {summary.failedCount > 0 && (
              <span style={{ ...badgeBase, background: "#F09595", color: "#501313" }}>
                {summary.failedCount} failed
              </span>
            )}
            <span style={{ ...badgeBase, background: "rgba(0,0,0,0.06)", color: "#444441", border: "0.5px solid rgba(0,0,0,0.1)" }}>
              {summary.totalSubmitted} total
            </span>
          </div>
        </div>

        {/* ── Divider ── */}
        <div style={{ height: "0.5px", background: dividerColor, margin: "10px 0" }} />

        {/* ── Device groups ── */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "10px" }}>

          {/* Success group */}
          {summary.successCount > 0 && (
            <div style={{ background: "rgba(255,255,255,0.6)", borderRadius: "8px", border: "0.5px solid rgba(0,0,0,0.08)", overflow: "hidden" }}>
              <div style={{ ...groupHeaderBase, background: "#9FE1CB", color: "#04342C" }}>
                <CheckCircleFilled style={{ fontSize: "13px" }} />
                Successfully created ({summary.successCount})
              </div>
              <div style={{ padding: "8px 10px", display: "flex", flexWrap: "wrap", gap: "5px" }}>
                {summary.successDeviceIDs.map((id, i) => (
                  <span key={i} style={{ ...tagBase, background: "#d1fbec", color: "#04342C" }}>{id}</span>
                ))}
              </div>
            </div>
          )}

          {/* Failed groups — one per error reason */}
          {summary.failedCount > 0 && Object.entries(summary.groupedErrors).map(([reason, ids], i) => (
            <div key={i} style={{ background: "rgba(255,255,255,0.6)", borderRadius: "8px", border: "0.5px solid rgba(0,0,0,0.08)", overflow: "hidden" }}>
              <div style={{ ...groupHeaderBase, background: "#F7C1C1", color: "#501313" }}>
                <InfoCircleFilled style={{ fontSize: "13px" }} />
                {reason} ({ids.length})
              </div>
              <div style={{ padding: "8px 10px", display: "flex", flexWrap: "wrap", gap: "5px" }}>
                {summary.failedDevices.map((id, j) => (
                  <span key={j} style={{ ...tagBase, background: "#fee8e8", color: "#501313" }}>{id}</span>
                ))}
              </div>
            </div>
          ))}

        </div>

        {/* ── Dismiss ── */}
        <div style={{ textAlign: "right", marginTop: "10px" }}>
          <button
            onClick={() => setState(prev => ({ ...prev, creationSummary: null }))}
            style={{
              background: "none",
              border: "none",
              fontSize: "12px",
              color: allSuccess ? "#0F6E56" : allFailed ? "#711B13" : "#0C447C",
              cursor: "pointer",
              padding: "2px 6px",
              borderRadius: "5px",
              opacity: 0.7,
            }}
            onMouseEnter={e => e.currentTarget.style.opacity = 1}
            onMouseLeave={e => e.currentTarget.style.opacity = 0.7}
          >
            Dismiss ✕
          </button>
        </div>

      </div>
    );
  };

  // Function to fetch hardware model and software version info from the server to populate the respective dropdowns. It also handles the API response and errors, updating the state accordingly.
  const getHWModelandSWversionInfo = () => {

    let modifiedState = state;

    let HwModelArr = [];
    let SwNameArr = [];

    let JsonParams = {
      ProductLine: SAU_ProductLine
    }

    axios.post(`${getAPIHostURL()}/wclient/getProductHWModelandCurrSWversionInfo`, JsonParams)
    .then(response => {
      if(response.data.code == 'SUCCESS') {
          let receivedProductHwModelCurrFwVersion = response.data.retrieveProductHwModelCurrFwVersion;

          if(receivedProductHwModelCurrFwVersion == null || receivedProductHwModelCurrFwVersion.length <= 0 ) {
              modifiedState.errors.others = "Unable to Get Hardware Model and Software version Information.";
          } else {
              modifiedState.HWandSWVersionInfoArr = receivedProductHwModelCurrFwVersion;

              for(let i = 0; i < receivedProductHwModelCurrFwVersion.length; i++) {
                  if(!HwModelArr.includes(receivedProductHwModelCurrFwVersion[i].ModelName)) { 
                      HwModelArr.push(receivedProductHwModelCurrFwVersion[i].ModelName);
                  }
                  if(!SwNameArr.includes(receivedProductHwModelCurrFwVersion[i].SoftwareName)) { 
                      SwNameArr.push(receivedProductHwModelCurrFwVersion[i].SoftwareName);
                  }
              }

              modifiedState.HardwareModelArr = HwModelArr;
              modifiedState.SoftwareNameArr = SwNameArr;
              getDeviceBatchInfo(modifiedState);
          }
      } else {
          if(response.data.code == 'SQL_ERROR' || response.data.code == 'REQ_PARAMS_MISSING') {
              modifiedState.errors = "Server experiencing issues.\nTry again later.";
          } else {
              console.log('Should not reach here');
              modifiedState.errors.others = "Server experiencing issues.\nTry again later.";
          }
      }
    })
    .catch( error => {
        console.log("Network error:");
        console.log(error);
        if (axios.isCancel(error)) {
            console.log('Axios request cancelled beacuse of too many requests being sent to the Server.');
        } else {
            modifiedState.errors.others = "Network issues.\nCheck your Internet and Try again later.";
            setState(modifiedState);
        }
    })
  }

  // Function to fetch device batch information from the server to populate the batch number dropdown. It also handles the API response and errors, updating the state accordingly.
  const getDeviceBatchInfo = (inModifiedState=null) => {

    let modifiedState = inModifiedState != null ? inModifiedState : state;

    let recievedBatchNoList = [];

    axios.post(`${getAPIHostURL()}/wclient/getDeviceBatchInfo`)
    .then(response => {

      if(response.data.code == 'SUCCESS') {

          if(response.data.retrievedBatchNoList == null || response.data.retrievedBatchNoList.length <= 0 ) {
              modifiedState.errors.others = "Unable to Get Device Batch Information.";
          } else {
              let BatchNoList = response.data.retrievedBatchNoList;
              for(let i = 0; i < BatchNoList.length; i++) {
                  if(!recievedBatchNoList.includes(BatchNoList[i].BatchNo)) { 
                      recievedBatchNoList.push(BatchNoList[i].BatchNo);
                  }
                }
          }
      } else {
          if(response.data.code == 'SQL_ERROR' || response.data.code == 'REQ_PARAMS_MISSING') {
              modifiedState.errors = "Server experiencing issues.\nTry again later.";
          } else {
              console.log('Should not reach here');
              modifiedState.errors.others = "Server experiencing issues.\nTry again later.";
          }
      }

      modifiedState.deviceBatchArr = recievedBatchNoList;
      setState(modifiedState);
    })
    .catch( error => {
        console.log("Network error:");
        console.log(error);
        if (axios.isCancel(error)) {
            console.log('Axios request cancelled beacuse of too many requests being sent to the Server.');
        } else {
            modifiedState.errors.others = "Network issues.\nCheck your Internet and Try again later.";
            setState(modifiedState);
        }
    })
  }

  // Final function called when user clicks on create device button.
  const createSAUDevices = async (e) => {

    e.preventDefault();

    let modifiedState = { ...state };

    modifiedState.errors = {
      arrDeviceList: "",
      others: "",
      selectedHwModel: "",
      selectedSWName: "",
      selectedSwVersion: "",
      selectedBatchNo: "",
    };

    modifiedState.errors.arrDeviceList =
      !modifiedState.arrDeviceList || modifiedState.arrDeviceList.length === 0
        ? "Add a Device"
        : "";

    modifiedState.errors.selectedHwModel =
      !modifiedState.selectedHwModel || modifiedState.selectedHwModel.length === 0
        ? "Hardware Model is Required."
        : "";
    
    modifiedState.errors.selectedSWName = !modifiedState.selectedSWName || modifiedState.selectedSWName.length === 0
        ? "Software Name is Required"
        : "";

    modifiedState.errors.selectedSwVersion = !modifiedState.selectedSwVersion || modifiedState.selectedSwVersion.length === 0
      ? "Software Version is Required"
      : "";

    modifiedState.errors.selectedBatchNo = !modifiedState.selectedBatchNo || modifiedState.selectedBatchNo.length === 0
      ? "Batch Number is Required"
      : "";


    const hasErrors = Object.values(modifiedState.errors).some(
      (err) => typeof err === "string" && err.length > 0
    );
  
    if (hasErrors) {
      setState({ ...modifiedState }); // show errors in UI
      return; 
    }
    
    // if no errors, show confirmation
    const confirmCreateSauDevices = window.confirm("Irreversible action — once a device is created, its details cannot be changed. Double-check the Device ID, Hardware Model, Firmware Version, and Batch No. before creating the devices. Do you want to create this devices?");
    if (!confirmCreateSauDevices) {
      alert("Device creation cancelled.");
      return;
    } 

    let arrDeviceIDWithAdtnlInfo = [];

    try {

      // Step 1 — fetch all auth keys in parallel
      arrDeviceIDWithAdtnlInfo = await Promise.all(
        modifiedState.arrDeviceList.map(async (device) => {
          const response = await axios.post(`${getAPIHostURL()}/wclient/getAuthkey`, { DeviceID: device.id });
          if (response.data.code !== "SUCCESS") {
            throw new Error(`Auth key fetch failed for ${device.id}`);
          }
          return {
            DeviceID:   device.id,
            DeviceAuth: response.data.AuthkeyForEachDevc,
          };
        })
      );
    } catch (error) {
      console.error("Error fetching auth keys:", error);
      alert("Failed to fetch auth keys for devices. Please try again.");
      return;
    }

    const jsonParams = {
      arrDeviceID: modifiedState.arrDeviceList.map(device => device.id),
      LoggedInUserID: context.loggedInUserInfo.userID,
      HWModel: modifiedState.selectedHwModel,
      SWName: modifiedState.selectedSWName,
      SWVersion: modifiedState.selectedSwVersion,
      DefaultOwnerEmailID: PROD_DEVC_OWNER_USER_ID,
      arrDeviceIDWithAdtnlInfo: arrDeviceIDWithAdtnlInfo,
      deviceBatchNo: modifiedState.selectedBatchNo
    }

    axios.post(`${getAPIHostURL()}/wclient/createSAUDevices`, jsonParams)
    .then((response) => {
      if (response.data.code === "SUCCESS") {

        
        if(response.data.arrFailedDevcWithErr == null || response.data.arrFailedDevcWithErr.length <= 0 ) {

            const failedCount = 0;
            const allSubmittedIDs = modifiedState.arrDeviceList.map(d => d.id);
            const successDeviceIDs = allSubmittedIDs;
            const successCount = successDeviceIDs.length;
            const groupedErrors = {};

            modifiedState.creationSummary = {
              successCount,
              failedCount,
              totalSubmitted: allSubmittedIDs.length,
              successDeviceIDs,   // ← new
              groupedErrors,
              failedDevices: []
            };

            alert("The Device Creation is successful");
            
        } else {

          const backendErrors = response.data.arrFailedDevcWithErr || [];
          const totalSubmitted = modifiedState.arrDeviceList.length;

          let groupedErrors = {};
          let failedDeviceIDs = [];

          // Some devices failed from backend are listed below.
          if (backendErrors.length > 0) {
            backendErrors.forEach((group, index) => {
              const readableMessage = group.Error;

              // Initialize array for this error message if not already present.
              if (!groupedErrors[readableMessage]) {
                groupedErrors[readableMessage] = [];
              }
                groupedErrors[readableMessage].push(group.Error);
                failedDeviceIDs.push(group.DeviceID);
            });
          }

          const failedCount = failedDeviceIDs.length;
          const allSubmittedIDs = modifiedState.arrDeviceList.map(d => d.id);
          const successDeviceIDs = allSubmittedIDs.filter(id => !failedDeviceIDs.includes(id));
          const successCount = successDeviceIDs.length;

          modifiedState.creationSummary = {
            successCount,
            failedCount,
            totalSubmitted: allSubmittedIDs.length,
            successDeviceIDs,   // ← new
            groupedErrors,
            failedDevices: failedDeviceIDs
          };
          
          alert(`Device Creation completed with some issues. ${successCount} succeeded, ${failedCount} failed. Check the summary note for details.`);
        }

        // reset form fields after creation
        modifiedState.deviceID =  "";
        modifiedState.arrDeviceList =  [];
        modifiedState.selectedHwModel = "";
        modifiedState.selectedSWName = "";
        modifiedState.selectedSwVersion = "";
        modifiedState.selectedBatchNo = ""; 

        // reset errors
        modifiedState.errors = {
          arrDeviceList: "",
          others: "",
          selectedHwModel: "",
          selectedSWName: "",
          selectedSwVersion: "",
          selectedBatchNo: "",
        };
      } else {
        if (response.data.code === "SQL_ERROR") {
          modifiedState.errors.others = "Server experiencing issues. Try again later.";
        } else if (response.data.code == 'REQ_PARAMS_MISSING') {
            modifiedState.errors.others = 'Server experiencing issues (required parameters not sent). Try again later.';
        } else {
          modifiedState.errors.others = "Server experiencing issues. Try again later.";
        }
      }
      setState(modifiedState);
    })
    .catch((error) => {
        setState((prev) => ({
          ...prev,
          errors: { ...prev.errors, others: "Network error. Please try again." },
        }));
    });
  }

  return (
    <div>
      <div className="modal-body addCustbox">
        <div
          className="headingForComponentsOfCrmPage"
          style={{
            marginBottom: "0.8rem",
            display: "block",
            alignSelf: "center",
          }}
        >
          Create New Smart Automation Device
        </div>

        {noteForUser()}      
        {creationSummaryNote()}               

        <form>
          <div className="deviceGroupBox" style={{paddingTop:"1.2rem", paddingBottom: "0.5rem", marginBottom: "0.8rem"}}>
            <div className="form-group addCustForm">
              <div className="inputgroupCustom" >
                <label className="addCustFormLabelWithRequiredFiledDeviceRegister">
                  Scan / Enter Device ID:
                  <span className="addCustRequiredMarkStarDeviceRegister">*</span>
                </label>

                <div className="addCustInputAndErrorDeviceRegister">
                  <div
                    style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    }}
                  >
                    <div className="inputWithIcon" style={{ flex: 1 }}>
                      <input
                        type="text"
                        style={{height: "2.2rem"}}
                        name="deviceID"
                        className="addCustInputForm"
                        value={state.deviceID}
                        required="required"
                        onChange={onChangedeviceID}
                        placeholder="Scan or enter Device ID"
                      />

                      <FaQrcode
                        className="inputIcon"
                        onClick={openQRCameraForPrdItmStateDevcID}
                        title="Scan QR"
                      />
                    </div>
                    <button
                      type="button"
                      className="addDeviceBtnInline"
                      onClick={addDevices}
                      >
                      Add
                    </button>
                  </div>
                    {state.devcIDQRCodeFlag && (
                      <div className="qrScannerWrapper">
                        <QrScanner style={{ width: "100%", background: "pink" }}
                          onDecode={(result) => {
                            handleScanResultOfPrdItmStateDevcID(result);
                          }}
                          onError={(error) => console.error(error)}
                          constraints={{ facingMode: "environment" }}
                        />
                      </div>
                    )}
                  </div>

                    
                    {errors.deviceID && (
                    <span className="addCustError">{errors.deviceID}</span> //frontend error
                    )}
                    {errors.deviceExistenceErr && (
                    <span className="addCustError">{errors.deviceExistenceErr}</span> //backend error
                    )}
                </div>
              </div>

              <div className="form-group addCustForm">
                <div className="inputgroupCustom">
                  <label className="addCustFormLabelWithoutRequiredFiled">
                    Added Devices:
                  </label>
                  <div className="addCustInputAndError">
                    <div className="deviceListBox">
                      {state.arrDeviceList?.length <= 0 && (
                        <div className="deviceEmptyText">No device added</div>
                      )}
                      {state.arrDeviceList?.length> 0 && state.arrDeviceList.map((device) => (                          
                        <div className="deviceListRow" key={device.id}>
                          <span className="deviceText">
                          <strong>{device.id}</strong> 
                          </span>
                          <FaTimes
                            className="deleteDeviceIcon"
                            title="Remove"
                            onClick={() => removeDevice(device.id)}
                          />
                        </div>                          
                      ))}
                    </div>
                    {errors.arrDeviceList && (
                      <span className="addCustError">{errors.arrDeviceList}</span>
                      )}
                    {state.errors.others.length > 0 && (
                <div className="form-error-message">{state.errors.others}</div>
                )}
                  </div>
                </div>
              </div>
            </div>
          
            <div className="addCustForm" style={{display: "block"}}>
              <div className="inputgroupCustom">
                <label style={{display:"block",alignContent:"center", marginTop:"0px", flexWrap:"wrap", marginRight: "5px"}} className="addCustFormLabelWithRequiredFiledDeviceRegister">
                  Select Hardware Model:
                  <span className="addCustRequiredMarkStar">*</span>
                </label>
                <div className="addCustInputAndError">
                  <select
                    style={{height: "2.2rem"}}
                    name="selectedHwModel"
                    className="addCustInputForm"
                    required = "required"
                    value={state.selectedHwModel}
                    onChange={handleChange}
                  >
                    <option value="">Select...</option>
                    {hardwareModels.map((type, index) => (
                    <option key={index} value={type}>{type}</option>
                    ))}
                  </select>
                  {errors.selectedHwModel && (
                    <span className="addCustError">{errors.selectedHwModel}</span>
                  )}
                </div>
              </div>
            </div>

            <div className="addCustForm" style={{ display: "block" }}>
              <div className="inputgroupCustom">
                <label style={{display:"block",alignContent:"center", marginTop:"0px", flexWrap:"wrap", marginRight: "5px"}} className="addCustFormLabelWithRequiredFiled">
                  Select Software/Firmware Name:<span className="addCustRequiredMarkStar">*</span>
                </label>
                <div className="addCustInputAndError">
                  <div className="inlineInputWithBtn">
                    <select
                    type="text"
                      style={{height: "2.2rem"}}
                      name="selectedSWName"
                      className="addCustInputForm"
                      value={state.selectedSWName}
                      onChange={handleChange}
                      >
                      <option value="">Select...</option>
                      {softwareNames.map((type, index) => (
                      <option key={index} value={type}>{type}</option>
                      ))}
                    </select>
                  </div>
                  {errors.selectedSWName && (
                    <span className="addCustError">{errors.selectedSWName}</span>
                  )}
                </div>
              </div>
            </div>

            <div className="addCustForm" style={{display: "block"}}>
              <div className="inputgroupCustom">
                <label style={{display:"block",alignContent:"center", marginTop:"0px", flexWrap:"wrap", marginRight: "5px"}} className="addCustFormLabelWithRequiredFiled">
                  Select Software/Firmware Version:
                  <span className="addCustRequiredMarkStar">*</span>
                </label>
                <div className="addCustInputAndError">
                  <div className="inlineInputWithBtn">
                    <select
                    type="text"
                      style={{height: "2.2rem"}}
                      name="selectedSwVersion"
                      className="addCustInputForm"
                      value={state.selectedSwVersion}
                      onChange={handleChange}
                      >
                      <option value="">Select...</option>
                      {versions.map((type, index) => (
                      <option key={index} value={type}>{type}</option>
                      ))}
                    </select>
                  </div>
                  {errors.selectedSwVersion && (
                    <span className="addCustError">{errors.selectedSwVersion}</span>
                  )}
                </div>
              </div>
            </div>

            <div className="addCustForm" style={{ display: "block" }}>
              <div className="inputgroupCustom">
                <label style={{display:"block",alignContent:"center", marginTop:"0px", flexWrap:"wrap", marginRight: "5px"}} className="addCustFormLabelWithRequiredFiled">
                  Select Batch No:
                  <span className="addCustRequiredMarkStar">*</span>
                </label>
                <div className="addCustInputAndError">
                  <div className="inlineInputWithBtn">
                    <select
                    type="text"
                      style={{height: "2.2rem"}}
                      name="selectedBatchNo"
                      className="addCustInputForm"
                      value={state.selectedBatchNo}
                      onChange={handleChange}
                      >
                      <option value="">Select...</option>
                      {state.deviceBatchArr.map((type, index) => (
                      <option key={index} value={type}>{type}</option>
                      ))}
                    </select>
                  </div>
                  {errors.selectedBatchNo && (
                    <span className="addCustError">{errors.selectedBatchNo}</span>
                  )}
                </div>
              </div>
            </div>

            <div className="form-group addCustForm">
              {irreversibleActionNote()}
              <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                <button
                  type="submit"
                  className="addCustSubmitBtn"
                  onClick={createSAUDevices}
                >
                  Create Device(s)
                </button>
              </div>
            </div>
        </form>
      </div>
    </div>
  );
}
export default VcCreateSauDevice;
